import { hasKey } from "../exports/helpers.js";
export default function (data, key, newKey) {
    hasKey(data, key);
    newKey && hasKey(data, newKey, true);
    return newKey ? newKey : key;
}
//# sourceMappingURL=getKeyToUpdate.js.map